<template>
  <div class="container">
      <div class="color-gray66 pt20 pl30 tl fs20 fwbold">分析记录</div>
      <div v-if="recordList && recordList.length > 0">
        <div v-for="(item, index) in recordList" :key="index" class="listBox tl row-start-col-center" @click="gotoDetail(item, index)">
          <span class="fs20 fwbold color-gray66">{{index + 1}}.</span>
          <span class="ml10 fs16 color-gray66">{{getName(item)}}</span>
        </div>
      </div>
      <div v-else class="empty-tip tc color-gray99">
        暂无记录
      </div>
      <div class="row-center" style="margin: 30px 0px">
        <van-button class="button1Style" block type="info" @click="gotoSubmit">新增分析</van-button>
      </div>
      <div class="row-center" style="margin-bottom: 30px">
        <van-button class="button1Style" block type="info" @click="getList">刷新</van-button>
      </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { postAction } from '@/api/manage'
export default {
  name: 'ChatList',
  data() {
    return {
      recordList: [],
    }
  },
  computed: {
    userinfoLove() {
      return this.$store.getters.getUserinfoLove || {}
    },
    openid() {
      return this.userinfoLove.jsopenid
    },
    unionid() {
      return this.userinfoLove.unionid
    },
    code() {
      return this.$route.query.code ? this.$route.query.code : ''
    },
  },
  mounted() {
    // 本地调试：自动注入 mock 用户数据
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      this.$store.commit('setUserInfoLove', {
        unionid: 'oni4R6b8pwMrPWp0DoctYi4-Wx4M',
        jsopenid: 'mock_openid_67890',
        nickname: '测试用户',
        image: ''
      })
      this.getList()
      return
    }
    if (!this.unionid) {
      if (!this.code) {
        var url = encodeURIComponent(window.location.protocol + '//' + window.location.hostname + '/chatList')
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbb2af162829dc7fe&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
      } else {
        this.getJsLogin()
      }
    } else {
      this.getList()
    }
  },
  methods: {
    getJsLogin() {
      const url = '/xcxlove/double/jslogin'
      postAction(url, { code: this.code }).then(res => {
        if (res.data.code == 200 || res.data.code == 400) {
          this.userInfo = res.data.msg
          this.$store.commit('setUserInfoLove', this.userInfo)
          this.getList()
        }
      })
    },
    getName(item) {
      // 兼容字符串数组和对象数组
      if (typeof item === 'string') {
        return item
      }
      return item.name || item.session_id || '未命名'
    },
    getList() {
      const url = '/chat/history'
      postAction(url, { unionid: this.unionid }).then(res => {
        if (res.data.code == 200) {
          this.recordList = res.data.msg || []
        } else {
          Toast.fail(res.data.msg)
        }
      })
    },
    gotoDetail(item, index) {
      const name = this.getName(item)
      const sessionId = (typeof item === 'object' && item.session_id) ? item.session_id : ''
      this.$router.push({ path: '/chatDetail', query: { name: name, session_id: sessionId, index: index } })
    },
    gotoSubmit() {
      this.$router.push({ path: '/chatSubmit' })
    }
  }
}
</script>
<style scoped>
.container {
  width: 100%;
  min-height: 100vh;
  background-image: linear-gradient(rgb(242, 197, 204), rgb(255, 255, 255));
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.listBox {
  width: 75%;
  min-height: 50px;
  margin: 16px auto;
  padding: 10px 6px 10px 10px;
  border-radius: 0px 20px 20px 20px;
  box-shadow: 0 10px 6px -6px #777;
  background: rgb(251, 245, 245);
  cursor: pointer;
}
.empty-tip {
  padding: 60px 0;
  font-size: 16px;
}
.button1Style {
  background: rgb(255, 174, 191);
  border: 1px solid rgb(242, 197, 204);
  font-size: 19px;
  width: 150px;
  border-radius: 6px;
}
</style>
